import React from "react";

const PendingActivitiesBanner = ({
  title = "Pending Activities",
  subtitle = "Track active waiting, collection & in-transit orders",
  buttonText = "View Activities",
  count = 0,
  onClick,
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-3.5 shadow-sm mb-4 flex items-center justify-between flex-wrap gap-3">
      <div>
        <h4 className="font-gilroyBold text-[15px] text-gray-900 m-0 p-0 leading-tight">
          {title}
        </h4>
        <p className="text-[13px] text-gray-500 m-0 p-0 mt-0.5">
          {subtitle}
        </p>
      </div>

      <button
        onClick={onClick}
        className="px-4 py-2 bg-black hover:bg-gray-900 text-white rounded-xl text-[14px] font-gilroyBold transition-all duration-200 cursor-pointer flex items-center gap-2"
      >
        {buttonText}
        {count > 0 && (
          <span className="bg-white/20 text-white text-[12px] px-2 py-0.5 rounded-full font-gilroyBold">
            {count}
          </span>
        )}
      </button>
    </div>
  );
};

export default PendingActivitiesBanner;
